import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import _ from 'lodash';
import { Optional } from 'utility-types';
import {
  ModelCritiqueOutput,
  ModelCritiqueSeverity,
} from 'react-scale/components/scalers/tasks/ThreadedInteraction/hooks/useModelCritique';

// Extend the ModelCritiqueOutput to include optional properties
export type ExtendedModelCritiqueOutput = ModelCritiqueOutput & {
  opened?: boolean;
  feedbackAcknowledged?: boolean;
};

// Update the ModelCritiqueStateStore to use the extended type
type ModelCritiqueStateStore = {
  modelCritiqueState: Record<string, ExtendedModelCritiqueOutput>;
  setModelCritiqueState: (
    storeKey: string,
    newState: Optional<ExtendedModelCritiqueOutput>,
  ) => void;
  getModelCritiqueState: (storeKey: string) => ExtendedModelCritiqueOutput;
};

export const useModelCritiqueStore = create<ModelCritiqueStateStore>()(
  devtools((set, get) => ({
    modelCritiqueState: {},
    setModelCritiqueState: (storeKey: string, newState: Optional<ExtendedModelCritiqueOutput>) => {
      set(state => ({
        modelCritiqueState: {
          ...state.modelCritiqueState,
          [storeKey]: _.merge(state.modelCritiqueState[storeKey], newState),
        },
      }));
      return newState;
    },
    getModelCritiqueState: (storeKey: string) => {
      const cachedState = get().modelCritiqueState[storeKey];
      if (!cachedState) {
        return {
          critique: '',
          severity: ModelCritiqueSeverity.Missing,
          loading: false,
          fetched: false,
        };
      }
      return cachedState;
    },
  })),
);
